/**
 * PreviewLayoutContext — lets descendants know whether the AppShell's
 * preview drawer is currently open.
 *
 * `TaskRow` (and other list-density-sensitive components) consume this via
 * `usePreviewLayout()` to switch to a compact variant when the drawer claims
 * the third column, without the host having to thread an `open` prop through
 * every screen between `AppShell` and the row.
 */

import { createContext, useContext, type ReactNode } from 'react';

interface PreviewLayout {
  open: boolean;
}

const Ctx = createContext<PreviewLayout>({ open: false });

export function PreviewLayoutProvider({ open, children }: { open: boolean; children: ReactNode }) {
  return <Ctx.Provider value={{ open }}>{children}</Ctx.Provider>;
}

export function usePreviewLayout(): PreviewLayout {
  return useContext(Ctx);
}
